import type { FC, ReactNode } from 'react';

const OnBoardingSection: FC<{ title: string; children: ReactNode }> = ({ title, children }) => {
  return (
    <section>
      <h2 className="font-bold text-lg">{title}</h2>
      {children}
    </section>
  );
};

export default OnBoardingSection;
